/**
 * VodsCtrl controller
 * Show all VODs
 */

import { PLATFORM_TYPES } from 'app/core/constants'
import { getName, keyValue } from 'app/helpers/entity'
import { nbspify } from 'app/helpers/string'
import moment from 'moment'

// controller mixins
VodsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * VodsCtrl controller
 *
 * @class VodsCtrl
 * @memberof mwApp/vods
 * @see mwApp/vods
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/vods.controller:VodsCtrl
 */
/* @ngInject */
export default function VodsCtrl ($scope, $location, Network, VOD, Extension, UrlPolicy, authSvc) {
  var vm = this
  vm.isFound = true
  vm.platforms = PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }).map(getName) // platforms

  // get token generator id from extension
  const { tokenGeneratorId, tokenGeneratorName } = $location.search()
  vm.streamPolicyId = $location.search().streamPolicyId

  vm.onScrollUrlPolicies = UrlPolicy.getPolicies(vm.urlPolicies = [], true)
  vm.getUrlPoliciesForStSelect = function (select) {
    select.open && vm.onScrollUrlPolicies(undefined, { q: select.search })
  }

  // get packages
  Network.loadAll('?vod=true')
    .then(networks => { vm.packages = networks.map(keyValue()) })

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Playback token generator name
   *
   * @memberof mwApp/vods.controller:VodsCtrl
   * @type {String}
   */
  vm.tokenGeneratorName = tokenGeneratorName

  /**
   * VODs list
   *
   * @memberof mwApp/vods.controller:VodsCtrl
   * @type {models.VOD[]}
   */
  vm.vods = []

  /**
   * Get VODs from backend
   *
   * @memberof mwApp/vods.controller:VodsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getVods = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    var pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}

    // add filter by token generator
    if (tokenGeneratorId) {
      pObject.tokenGeneratorId = tokenGeneratorId
    }

    // add filter by streamPolicyId
    if (vm.streamPolicyId) {
      pObject.streamPolicyId = vm.streamPolicyId
      vm.streamPolicyId = null
    }

    VOD.loadSmart(tableState)
      .then(
        data => {
          vm.vods = data.content
          vm.isFound = !!vm.vods.length

          $scope.loading = false
        }
      )
  }

  vm.tokenFormatter = function (str) {
    return nbspify(str)
  }

  /**
   * Delete VOD
   *
   * @memberof mwApp/vods.controller:VodsCtrl
   * @param {models.VOD} vod
   */
  vm.delete = function (vod) {
    vod._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }

  /**
   * Generate status by vod
   * @param {models.VOD} vod
   * @return {String}
   */
  vm.generateVodStatus = function (vod) {
    if (vod.enabled) { return 'play green' }

    return vod.publishTime && moment().diff(vod.publishTime) < 0 ? 'time' : 'pause orange'
  }

  /**
   * Toggle VOD status
   * @param {models.VOD} entity current VOD
   */
  vm.toggleVODStatus = function (entity) {
    vm.onOff(entity)
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
